import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ACTIONS_TYPES, actions } from 'redux/local';
import Shared from 'screens/shared';
import ALB from 'screens/alb';
import CreateForm from 'screens/data-centers/create';
import { getUnattachedVolumes } from 'utils';
import { ROUTE } from 'constant';
import { featuresToggle } from 'utils/features-toggle';
import NLB from 'screens/nlb';

export default ({ history, match }) => {
  const id = match.params?.id;

  const { [ACTIONS_TYPES.DATA_CENTER.GET]: datacenter = {} } = useSelector((e) => e);
  const { entities = {}, properties: dcProps = {} } = datacenter;

  useEffect(() => {
    actions.dataCenter.get({ id });
  }, [id]);

  const unattachedVolumes = getUnattachedVolumes(datacenter);

  const deleteHandler = () => {
    actions.dataCenter.delete({ id });
    history.push(ROUTE.DASHBOARD.DATA_CENTERS.path);
  };

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.DATA_CENTER}
      strapIcon="boxes"
      strapTitle={dcProps?.name}
      strapSubTitle={<Shared.utilities.Location location={dcProps?.location} />}
      onDelete={deleteHandler}
      editForm={<CreateForm isUpdate id={id} />}
      editAction={ACTIONS_TYPES.DATA_CENTER.UPDATE}
    >
      <Shared.components.Servers.List servers={entities?.servers?.items || []} history={history} dcId={id} />
      <Shared.components.Loadbalancers loadbalancers={entities?.loadbalancers?.items || []} history={history} dcId={id} />
      {featuresToggle.isExistInConfig('vnf-lb') && dcProps?.features?.includes?.('vnf-lb') && (
        <NLB.NLBList networkLoadBalancers={entities?.networkloadbalancers?.items || []} history={history} dcId={id} />
      )}

      {featuresToggle.isALB() && (
        <ALB.List items={entities?.applicationloadbalancers?.items || []} history={history} dcId={id} />
      )}

      <Shared.components.NATGateway natGateways={entities?.natgateways?.items || []} history={history} dcId={id} />
      <Shared.components.Storages title="Unattached Storages" storages={unattachedVolumes} history={history} dcId={id} />
      <Shared.components.Lans lans={entities?.lans?.items || []} history={history} dcId={id} />
    </Shared.widgets.Page>
  );
};
